// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__3AJaM","menuText":"MenuItem_menuText__2U7Bn","isActive":"MenuItem_isActive__1HoWI"};